/* Package JSON Import will be here */
import React from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector, useDispatch } from "react-redux";
import { Col, Switch } from "antd";
/* Package JSON Import will be here */

/* Project Import will be here */
import {
    checkEligibleForFoc,
    errorToast,
    checkAnyNonFocProductsAddedInCart
} from "utilities/utils";
import TooltipComp from "components/reusable/TooltipComp";
import modalConfirmationHook from "hooks/modalConfirmationHook";
import { changeFocStatus } from "reducers/common";
import { removeAllChangedProductFromOrderReducer } from "reducers/orders";
/* Project Import will be here */

const FocSwitchComp = (props) => {
    const { translate, common, orders, cart } = useSelector((state) => ({
        common: state.common,
        orders: state.orders,
        cart: state.cart,
        translate: getTranslate(state.locale)
    }));

    const dispatch = useDispatch();

    const enableOrDisableFocAndLoadProducts = async () => {
        await dispatch(changeFocStatus(!common.isFocSelected));

        /* Fetch the product list bases on the FOC selection */
        await props.getProductList();
    }

    /* Enable the FOC */
    const onChangeFocSwitch = async () => {
        /* Check for if any non FOC products added in the cart */
        if (checkEligibleForFoc(orders, true)) {
            /* if the retailer turn off the switch we need to validate*/
            if (common.isFocSelected && cart.ids.length > 0) {
                errorToast({
                    content: translate("products.foc.focRequestValidation")
                });
            }
            else if (common.isFocSelected && cart.ids.length === 0 && !checkEligibleForFoc(orders, false)) {
                /* Ask for clear the added products in the local */
                modalConfirmationHook(translate("common.alerts.confirmation.removedAddedFocProductInLocalStoreConfirmationTitle"),
                    translate,
                    (async () => {
                        await dispatch(removeAllChangedProductFromOrderReducer());
                        enableOrDisableFocAndLoadProducts();
                    }));
            }
            else {
                if (!checkAnyNonFocProductsAddedInCart(cart.data)) {
                    enableOrDisableFocAndLoadProducts();
                }
                else {
                    errorToast({
                        content: translate("products.foc.nonFocRequestValidation")
                    });
                }
            }
        }
        else {
            /* Check for if any products added in the cart */
            if (cart.ids.length <= 0) {
                /* Ask for clear the added products in the local */
                modalConfirmationHook(translate("common.alerts.confirmation.removedAddedNonFocProductInLocalStoreConfirmationTitle"),
                    translate,
                    (async () => {
                        await dispatch(removeAllChangedProductFromOrderReducer());
                        enableOrDisableFocAndLoadProducts();
                    }));
            }
            else {
                if (common.isFocSelected) {
                    enableOrDisableFocAndLoadProducts();
                }
                else {
                    errorToast({
                        content: translate("products.foc.nonFocRequestValidation")
                    });
                }
            }
        }
    }

    return (
        <React.Fragment>
            <Col flex="none" className="pl-2 pr-2">
                <div className="responsive-font-size float-right">
                    <TooltipComp title={translate("products.showFocProducts")}>
                        {translate("products.productLabel.trial")}
                        <Switch size="small" className="ml-1" checked={common.isFocSelected} onChange={onChangeFocSwitch} />
                    </TooltipComp>
                </div>
            </Col>
        </React.Fragment>
    );
};

export default FocSwitchComp;